/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  IconButton,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';

const tooltipInformation = () => {
  return (
    <Box>
      <Typography fontSize={12}>
        Please ensure all required data fields have been filled in (Follow-Ups
        and Responses Sent). Once complete, please select Save to save this
        week&apos;s final numbers; then, you will be able to edit next
        week&apos;s log sheet
      </Typography>
      <Typography fontSize={12} mt={1}>
        *If you do not have data for a certain field or day. please enter the
        value &quot;O&quot;.
      </Typography>
      <Typography fontSize={12} mt={1}>
        *If you were OOO on a certain day, please select the applicable
        drop-down in the Out of Office column for that date. Please note that
        weekends will always default to &quot;Full&quot;. i.e. Holiday, PTO,
        Sick Leave.
      </Typography>
    </Box>
  );
};

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const WeeklyLogSaveToolTip = () => {
  return (
    <HtmlTooltip title={tooltipInformation()} placement="top-start">
      <IconButton sx={{ fontSize: 20 }}>
        <HelpRoundedIcon fontSize="inherit" />
      </IconButton>
    </HtmlTooltip>
  );
};

export default WeeklyLogSaveToolTip;
